import classNames from 'classnames';

import FormError from './FormError';

const CheckBox = (props) => {
  const {
    input,
    label,
    meta: { touched, error }
  } = props;
  return (
    <div className={classNames(touched && error && 'c7-error')}>
      <label
        htmlFor={`c7-checkbox${input.name}-${input.value}`}
        className="checkbox"
      >
        <input
          type="checkbox"
          id={`c7-checkbox${input.name}-${input.value}`}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...input}
          value={input.value}
          checked={input.checked}
        />
        {label}
      </label>
      <FormError touched={touched} error={error} />
    </div>
  );
};

export default CheckBox;
